import PropTypes from "prop-types"
import React from "react"
import ReactSVG from "react-inlinesvg"

import { findColorByName, getIcon } from "./IconsSvg"
import css from "@utils/css"
import useMods from "@hooks/useMods"

const Icon = ({ mods={}, name, size=32, color, className: classNameTail = undefined, defsSalt="" }) => {
  const { className } = useMods(Icon, { mods })
  const [firstColor, secondColor] = findColorByName(color)
  const icon = getIcon(size, firstColor, secondColor, defsSalt)

  return (
    <i className={css(className, classNameTail)}>
      <ReactSVG src={icon[name]} />
    </i>
  )
}

Icon.displayName = "Icon"

Icon.propTypes = {
  color: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  defsSalt: PropTypes.string,
  mods: PropTypes.object,
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
}

export default Icon
